export default function WhyProgramsWork() {
  const steps = [
    {
      icon: 'ri-search-eye-line',
      title: 'Предварительный аудит',
      desc: 'Прослушиваем реальные звонки, анализируем переписки, изучаем типичные возражения ваших клиентов. Обучение строится на фактах, а не на догадках.',
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Адаптация программы',
      desc: 'Каждый модуль адаптируется под ваш продукт, рынок, цикл сделки и типичные сценарии. Нет универсальных скриптов — только ваши реальные ситуации.',
    },
    {
      icon: 'ri-briefcase-line',
      title: 'Практика на кейсах компании',
      desc: '80% времени — отработка на реальных разговорах ваших менеджеров. Ролевые переговоры, поединки, разбор ошибок и усиление рабочих приёмов.',
    },
    {
      icon: 'ri-book-open-line',
      title: 'Домашние задания',
      desc: 'Между модулями сотрудники применяют навыки в работе и получают обратную связь. Теория превращается в привычку до следующей встречи.',
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'Сопровождение после обучения',
      desc: 'Разборы новых звонков, корректировка стратегии, поддержка в чате. Эта последовательность превращает обучение в реальные изменения поведения и рост показателей.',
    },
  ];

  return (
    <section id="why-work" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Почему наши программы работают
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Именно эта последовательность позволяет превращать обучение в реальные изменения поведения сотрудников и рост бизнес-показателей.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {steps.map((step, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-6 text-center hover:bg-teal-50 transition-colors duration-300 border border-gray-100 hover:border-teal-200">
              <div className="w-14 h-14 bg-teal-600 rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className={`${step.icon} text-2xl text-white`}></i>
              </div>
              <div className="text-2xl font-extrabold text-teal-600 mb-2">{i + 1}</div>
              <h3 className="text-base font-bold text-gray-900 mb-2">{step.title}</h3>
              <p className="text-xs text-gray-600 leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}